import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCross12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCross12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M8.982 2.382a.45.45 0 1 1 .636.637L6.636 6l2.982 2.982a.45.45 0 0 1-.636.637L6 6.637 3.018 9.618a.45.45 0 0 1-.636-.636L5.364 6 2.382 3.02a.45.45 0 0 1 .636-.637L6 5.364z"
            />
        </svg>
    );
}
export default memo(IconCross12);
